import styled, { css } from 'styled-components';

// Import utilities
import { customMinResponsive, size } from 'components/styles';

export const Container = styled.div`
	margin-top: 1.2rem;
	order: 1;
	color: ${({ theme }) => theme.body.footer.color};
	font-size: ${({ theme }) => theme.fontSize.footer.media.text.mobile}rem;
	font-weight: ${({ theme }) => theme.font.light};
	line-height: 1.6rem;
	text-align: center;

	a {
		text-decoration: none;
		color: ${({ theme }) => theme.white};

		&:hover {
			color: ${({ theme: { body } }) => body.footer.hover};
		}

		&:focus-visible {
			color: ${({ theme: { body } }) => body.footer.hover};
		}
	}

	${customMinResponsive(
		size.medium,
		css`
			margin-top: 1rem;
			order: 0;
			width: 100%;
			text-align: center;
			font-weight: ${({ theme }) => theme.font.light};
			font-size: ${({ theme }) => theme.fontSize.footer.media.text.desktop}rem;
			line-height: 2rem;
		`
	)};
`;
